import MobilePhotoWrapper from '../src/MobilePhotoWrapper.tsx';
export default MobilePhotoWrapper;
